import {
  RESOURCE_FILTER_ORDER,
  type ResourceFilter,
  ResourceFilterLabels,
} from "../../../domains/TimelineResourceFilter";
import SwitchTabs from "../../molecules/SwitchTabs";

type Props = {
  // 選択中のフィルタ
  value: ResourceFilter;
  // フィルタ押下時の通知
  onChange: (next: ResourceFilter) => void;
  // FILTER-03: 校舎に AI質問契約者が一人もいなければ非表示。呼び出し側が判定を渡す
  visible: boolean;
};

// 「すべて / 学習記録 / AI質問」フィルタボタン群（プレゼンテーショナル）。
// 共通の SwitchTabs を流用する。状態管理・データ取得は持たず、消費側（WEB-1713/1715）がマウント・配線する。
export const TimelineResourceFilter = ({ value, onChange, visible }: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <SwitchTabs
      tabs={RESOURCE_FILTER_ORDER.map((filter) => ({
        id: filter,
        label: ResourceFilterLabels[filter],
        active: filter === value,
      }))}
      onClickTab={(tab) => () => onChange(tab.id as ResourceFilter)}
    />
  );
};
